import * as yup from "yup";

export const agriSubsidyScheama = yup.object().shape({
  name: yup.string().required("required"),
  phoneNo: yup.number().required("required"),
  state: yup.string().required("required"),
  district: yup.string().required("required"),
  taluka: yup.string().required("required"),
  vName: yup.string().required("required"),
  empStatus: yup.string().required("required"),
  farmerId: yup.string().required("required"),
  // subsidy: yup.array().min(1, "Please select at least one subsidy"),
});
